import {
  IOAuth2LoginParams,
  IOAuth2RefreshParams,
  IPaginationParams
} from 'src/api/'
import * as IRequests from 'src/api/interfaces/requests'
import { IWindowJsEnv } from 'src/interfaces/'

const _window = window as unknown as IWindowJsEnv

export const $pagination = (params: IPaginationParams): IRequests.IPaginationParams => ({
  order_by: params.orderBy,
  page: params.page ? params.page.toString() : undefined,
  per_page: params.perPage ? params.perPage.toString() : undefined,
  sort_by: params.sortBy
})

export const $conversationCreate =
  (profileType: string, profileId: string): IRequests.IConversationCreateParams => ({
    participants: [
      `${profileType}#${profileId}`
    ]
  })

export const $messageCreate =
  (body?: string, images?: string[], linkPreviewUrl?: string): IRequests.IMessageCreateParams => ({
    message: {
      attachments_attributes: buildAttachments(images),
      body,
      link_preview_url: linkPreviewUrl
    }
  })

export const $conversationMessage = (params: IPaginationParams): IRequests.IPaginationParams =>
  $pagination(params)

// Helper to build the 'attachments_attributes'-param.
const buildAttachments = (images?: string[]): IRequests.IAttachmentAttribute[] | undefined => {
  return images ? images.map((image: string) => ({ file: image })) : undefined
}

export const $oauth2Login = (params: IOAuth2LoginParams): IRequests.IOAuth2ResourceOwnerPasswordCredentials => ({
  client_id: _window.js_env.oauth_client_id,
  grant_type: 'password',
  password: params.password,
  username: params.email
})

export const $oauth2Refresh = (params: IOAuth2RefreshParams): IRequests.IOAuth2Refresh => ({
  client_id: _window.js_env.oauth_client_id,
  grant_type: 'refresh_token',
  refresh_token: params.refreshToken
})

export const $resendConfirmationEmail = (redirectUrl: string): IRequests.IResendConfirmationEmail => ({
  redirect_url: redirectUrl
})
